import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { userStore } from "../../stores/userStore";

import "./AppFooter.css";

export type AppFooterVariant = "default" | "dark";

interface AppFooterProps {
  variant?: AppFooterVariant;
}

const AppFooter = observer(function AppFooter({ variant = "default" }: AppFooterProps) {
  const { t } = useTranslation();
  const isRuRegion = userStore.isRuRegion;
  const siteUrl = isRuRegion ? "https://nextgis.ru" : "https://nextgis.com";
  const email = isRuRegion ? "info@nextgis.ru" : "info@nextgis.com";
  const year = new Date().getFullYear();

  return (
    <footer
      className={`app-footer${variant === "dark" ? " app-footer--dark" : ""}`}
    >
      <div className="app-footer__inner">
        <div className="app-footer__left">
          <span className="app-footer__copyright">
            &copy; {year}{" "}
            <a href={siteUrl} target="_blank" rel="noreferrer">
              NextGIS
            </a>
          </span>
          <a className="app-footer__email" href={`mailto:${email}`}>
            {email}
          </a>
        </div>
        <div className="app-footer__right">
          <a href={`${siteUrl}/terms/`} target="_blank" rel="noreferrer">
            {t("footer.terms")}
          </a>
          <a href={`${siteUrl}/privacy/`} target="_blank" rel="noreferrer">
            {t("footer.privacy")}
          </a>
        </div>
      </div>
    </footer>
  );
});

export default AppFooter;
